import { render, staticRenderFns } from "./DeckShare.vue?vue&type=template&id=83ca2fc6&scoped=true"
import script from "./DeckShare.vue?vue&type=script&lang=js"
export * from "./DeckShare.vue?vue&type=script&lang=js"
import style0 from "./DeckShare.vue?vue&type=style&index=0&id=83ca2fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ca2fc6",
  null
  
)

export default component.exports